import React from 'react';
import {Link, useLocation} from "react-router-dom";
import './navigationMeny.css';

const NavigationMenu = () => {

    let location = useLocation();

    const isCurrentUrl = (url:string):boolean => {
      return  location.pathname.includes(url);
    }

    return (
        <div className={"container-fluid navigation-menu"}>
            <div className={"container"}>
                <div className={"navigation-menu__navbar"} >
                    <Link to={'cart'} className={`navigation-menu__item ${isCurrentUrl("cart") && "active"}`}>
                        <i className="bi bi-basket-fill me-1"></i>
                        <span>Корзина</span>
                    </Link>
                    <Link to={'favourite'} className={`navigation-menu__item ${isCurrentUrl("favourite") && "active"}`}>
                        <i className="bi bi-star-fill me-1"></i>
                        <span>Избранное</span>
                    </Link>
                    <Link to={'history'} className={`navigation-menu__item ${isCurrentUrl("history") && "active"}`}>
                        <i className="bi bi-book me-1"></i>
                        <span>История заказов</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NavigationMenu;